"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusIconAppearance = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../components/Icon/index");
/**
 * Returns an icon based on appearance.
 *
 * @param {object} props
 * @param {string} props.appearance - One of "success", "warning", "error", "info", "transient"
 */
// eslint-disable-next-line zillow/react/prop-types
var statusIconAppearance = function statusIconAppearance(_ref) {
  var appearance = _ref.appearance;
  switch (appearance) {
    case 'success':
    case 'complete':
      return /*#__PURE__*/_react.default.createElement(_index.IconCheckmarkCircle, null);
    case 'warning':
      return /*#__PURE__*/_react.default.createElement(_index.IconWarning, null);
    case 'error':
      return /*#__PURE__*/_react.default.createElement(_index.IconError, null);
    case 'info':
      return /*#__PURE__*/_react.default.createElement(_index.IconInfo, null);
    case 'transient':
      return /*#__PURE__*/_react.default.createElement(_index.IconWaiting, null);
    case 'incomplete':
      return /*#__PURE__*/_react.default.createElement(_index.IconMinusCircle, null);
    default:
      return null;
  }
};
exports.statusIconAppearance = statusIconAppearance;